export const messages = {
  en: {
    assetImportLogDetail: {
      title: 'Import Details',
      importTime: 'Import Time',
      status: 'Status',
      description: 'Description',
      all: 'All',
      waitingImport: 'Waiting Import',
      success: 'Success',
      failed: 'Failed',
      refresh: 'Refresh',
      back: 'Back'
    }
  },
  zh: {
    assetImportLogDetail: {
      title: '导入详情',
      importTime: '导入时间',
      status: '状态',
      description: '描述',
      all: '全部',
      waitingImport: '待导入',
      success: '成功',
      failed: '失败',
      refresh: '刷新',
      back: '返回'
    }
  }
}